import styled from "@emotion/styled";

export const StyledCurrentSubscription = styled.div`
  padding: 20px;
  border-radius: 10px;
  background: white;

  &.canceled {
    .subscription-title {
      color: red !important;
    }
    .total-card {
      background: red !important;
      border: none !important;
    }
  }

  .subscription-header {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 20px;
    justify-content: space-between;

    .subscription-title {
      margin: 0 !important;
      font-size: 18px !important;
      font-weight: 600 !important;
      color: #1a1a2e;
    }

    .billing-tag {
      font-size: 12px;
      font-weight: 500;
      border-radius: 20px;
      padding: 2px 10px;
      margin-left: 10px;
    }
  }

  .plans-row {
    margin-bottom: 16px;
  }

  .plan-card {
    margin-bottom: 20px;
    border-radius: 12px !important;
    border: 1.5px solid #f0f0f0 !important;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06) !important;
    transition:
      box-shadow 0.2s ease,
      border-color 0.2s ease;

    &:hover {
      box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1) !important;
    }

    .ant-card-body {
      padding: 20px;
    }

    &.enterprise-card {
      border-color: #d6e4ff !important;
      background: #fafcff;

      &:hover {
        border-color: #85a5ff !important;
      }
    }

    &.seat-card {
      border-color: #d9f7be !important;
      background: #fafffe;

      &:hover {
        border-color: #73d13d !important;
      }
    }
  }

  .card-icon-row {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 14px;

    .card-icon {
      width: 36px;
      height: 36px;
      border-radius: 8px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 16px;

      &.enterprise-icon {
        background: #e6f0ff;
        color: var(--primary);
      }

      &.seat-icon {
        background: #f6ffed;
        color: #52c41a;
      }
    }

    .plan-type-tag {
      border-radius: 20px;
      font-size: 11px;
      font-weight: 600;
      letter-spacing: 0.3px;
      padding: 2px 10px;

      &.enterprise-tag {
        background: #f0f5ff;
        border-color: #adc6ff;
        color: var(--primary);
      }

      &.seat-tag {
        background: #f6ffed;
        border-color: #b7eb8f;
        color: #389e0d;
      }
    }
  }

  .plan-name {
    margin: 0 0 6px !important;
    font-size: 15px !important;
    font-weight: 600 !important;
    color: #1a1a2e !important;
  }

  .plan-description {
    font-size: 12.5px;
    color: #8c8c8c;
    line-height: 1.5;
    display: block;
  }

  .card-divider {
    margin: 14px 0 !important;
    border-color: #f0f0f0 !important;
  }

  .price-row {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .price-label {
      font-size: 12.5px;
      color: #8c8c8c;
    }

    .price-value {
      font-size: 18px;
      font-weight: 700;

      .price-period {
        font-size: 12px;
        font-weight: 400;
        color: #8c8c8c;
        margin-left: 2px;
      }

      &.enterprise-price {
        color: var(--primary);
      }

      &.seat-price {
        color: #389e0d;
      }
    }
  }

  .seat-breakdown {
    display: flex;
    flex-direction: column;
    gap: 8px;

    .seat-detail-row {
      display: flex;
      align-items: center;
      justify-content: space-between;

      .price-label {
        font-size: 12.5px;
        color: #8c8c8c;
      }

      .seat-unit-price,
      .seat-quantity {
        font-size: 13px;
        font-weight: 600;
        color: #434343;
      }
    }
  }

  .total-card {
    border-radius: 12px !important;
    border: 1.5px solid var(--primary) !important;
    background: var(--primary) !important;
    box-shadow: 0 4px 16px rgba(47, 84, 235, 0.3) !important;

    .ant-card-body {
      padding: 20px 24px;
    }

    .total-label {
      font-size: 13px;
      font-weight: 600;
      color: rgba(255, 255, 255, 0.85);
      letter-spacing: 0.4px;
      text-transform: uppercase;
    }

    .total-breakdown {
      font-size: 12px;
      color: rgba(255, 255, 255, 0.6);
      margin-top: 2px;
      display: block;
    }

    .total-amount-col {
      text-align: right;

      @media (max-width: 575px) {
        text-align: left;
      }
    }

    .grand-total-stat {
      .ant-statistic-content {
        color: #ffffff !important;
        font-size: 28px !important;
        font-weight: 700 !important;
        line-height: 1.2;
      }

      .ant-statistic-content-prefix {
        font-size: 20px !important;
        color: rgba(255, 255, 255, 0.85) !important;
      }

      .total-suffix {
        font-size: 13px;
        font-weight: 400;
        color: rgba(255, 255, 255, 0.65);
        margin-left: 4px;
      }
    }
  }

  .transaction-table {
    border: 1px solid var(--border);
    border-radius: 10px;
  }

  @media (max-width: 768px) {
    .transaction-table {
      margin-top: 20px;
    }
  }
`;
